import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const Products = () => {
  return (
    <div className="min-h-screen bg-white text-black pt-24">
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* SerumAI Section */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-32"
        >
          <div className="text-center max-w-4xl mx-auto mb-16">
            <h2 className="text-5xl md:text-6xl font-bold mb-6">
              <span className="bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 bg-clip-text text-transparent">
                SerumAI
              </span>
            </h2>
            <p className="text-black/60 text-xl mb-8">
              Smart Enhanced Reactive Universal Machine
            </p>
            
            {/* Floating gradient aura animation */}
            <div className="relative inline-block">
              <motion.div
                className="absolute inset-0 bg-gradient-to-r from-blue-400/20 via-purple-400/20 to-pink-400/20 blur-3xl"
                animate={{
                  scale: [1, 1.2, 1],
                  opacity: [0.3, 0.5, 0.3]
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }}
              />
              <div className="relative bg-black/5 backdrop-blur-sm rounded-2xl p-12 border border-black/10">
                <p className="text-black/70 leading-relaxed max-w-2xl">
                  Our flagship AI platform combining neural processing, adaptive learning, and real-time intelligence to power the next generation of smart systems.
                </p>
              </div>
            </div>

            <Link
              to="/coming-soon"
              className="inline-flex items-center mt-12 px-8 py-4 bg-black text-white rounded-2xl font-medium hover:scale-[1.02] transition-transform duration-200"
            >
              Explore
              <ArrowRight size={20} className="ml-2" />
            </Link>
          </div>
        </motion.section>

        {/* X1 Humanoid Section */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <div className="max-w-5xl mx-auto">
            <h2 className="text-5xl md:text-6xl font-bold mb-12 text-center">X1 Humanoid</h2>
            
            {/* Placeholder image */}
           <div className="h-96 mb-8 rounded-2xl overflow-hidden bg-black/5 border border-black/10">
  <img
    src="/images/products/image.png"
    alt="X1 Humanoid Robot"
    className="w-full h-full object-contain"
  />
</div>


            {/* Specs */}
            <div className="flex flex-wrap justify-center gap-8 mb-12">
              <div className="text-center">
                <p className="text-sm text-black/50 mb-1">Battery</p>
                <p className="text-xl font-semibold">8h</p>
              </div>
              <div className="w-px bg-black/20" />
              <div className="text-center">
                <p className="text-sm text-black/50 mb-1">Vision</p>
                <p className="text-xl font-semibold">Yes</p>
              </div>
              <div className="w-px bg-black/20" />
              <div className="text-center">
                <p className="text-sm text-black/50 mb-1">Voice</p>
                <p className="text-xl font-semibold">Yes</p>
              </div>
              <div className="w-px bg-black/20" />
              <div className="text-center">
                <p className="text-sm text-black/50 mb-1">SerumAI</p>
                <p className="text-xl font-semibold">Included</p>
              </div>
            </div>

            <div className="text-center">
              <p className="text-black/70 leading-relaxed max-w-2xl mx-auto mb-8">
                The X1 Humanoid represents the pinnacle of robotic engineering—combining advanced mobility, visual perception, natural voice interaction, and powered by SerumAI for intelligent decision-making.
              </p>
              <Link
                to="/coming-soon"
                className="inline-flex items-center px-8 py-4 bg-black text-white rounded-2xl font-medium hover:scale-[1.02] transition-transform duration-200"
              >
                Learn More
                <ArrowRight size={20} className="ml-2" />
              </Link>
            </div>
          </div>
        </motion.section>
      </div>
    </div>
  );
};

export default Products;